import { EmptyControl, Required } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { TimeConstrainedBaseModel } from 'humanresources-common-shared';
import { PerPeopleModel } from './per-people-model';

@JsonObject('KovanHrMasterDataModel')
export class MasterDataModel extends TimeConstrainedBaseModel {
    @Required()
    @JsonProperty('hrmTypeUuid', String, true)
    hrmTypeUuid: string = null;

    @Required()
    @JsonProperty('perPeopleId', Number, true)
    perPeopleId: number = null;

    @JsonProperty('perPeople', PerPeopleModel, true)
    perPeople: PerPeopleModel = null;

    @JsonProperty('hrmTypeText', String, true)
    hrmTypeText: string = null;

    @EmptyControl()
    @JsonProperty('rejectReason', String, true)
    rejectReason: string = null;
}
